import { render, staticRenderFns } from "./TimerComponent.vue?vue&type=template&id=2ae5ec12&scoped=true"
import script from "./TimerComponent.vue?vue&type=script&lang=js"
export * from "./TimerComponent.vue?vue&type=script&lang=js"
import style0 from "./TimerComponent.vue?vue&type=style&index=0&id=2ae5ec12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5ec12",
  null
  
)

export default component.exports